var FcProblemInputModule = /** @class */ (function () {
    function FcProblemInputModule() {
    }
    return FcProblemInputModule;
}());
export { FcProblemInputModule };
